import { FTService } from '@services/ForfaitService'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { FinessDto, ICategory, Zone } from '../reducers/ForfaitReducer'


export const getModality = createAsyncThunk<ICategory[]>(
  'FT/GET_MODALITY',
  async (_, { rejectWithValue }) => {
    try {
      return await FTService.getModality()
    } catch (e: any) {
      return rejectWithValue(e.response.data.message)
    }
  },
)

export const getCategory = createAsyncThunk<ICategory[]>(
  'FT/GET_CATEGORY',
  async (_, { rejectWithValue }) => {
    try {
      return await FTService.getCategory()
    } catch (e: any) {
      return rejectWithValue(e.response.data.message)
    }
  },
)

export const getZoneGeographique = createAsyncThunk<Zone[]>(
  'FT/GET_ZONE_GEOGRAPHIQUE',
  async (_, { rejectWithValue }) => {
    try {
      return await FTService.getZoneGeographique()
    } catch (e: any) {
      return rejectWithValue(e.response.data.message)
    }
  },
)

export const getFiness = createAsyncThunk<FinessDto[]>(
  'FT/GET_FINESS',
  async (_, { rejectWithValue }) => {
    try {
      return await FTService.getFiness()
    } catch (e: any) {
      return rejectWithValue(e.response.data.message)
    }
  },
)